import payform from 'payform';
/* eslint-disable */

// Function to format credit card number inputs
// This only formats the input; if you want to validate, implement additional logic to file php

export const initFormatValue = () => {
	document.querySelectorAll("[data-card-number]").forEach((input) => {
		payform.cardNumberInput(input);
	});

	// Select all inputs that have the attribute data-card-expiry
	document.querySelectorAll("[data-card-expiry]").forEach((input) => {
		payform.expiryInput(input);
	});

	document.querySelectorAll("[data-card-cvc]").forEach((input) => {
		payform.cvcInput(input);
	});
};
